<template>
	<div>
		<el-dialog
			title="新增变动记录"
			:visible.sync="dialogVisible"
			width="40%"
			top="10vh"
			:close-on-click-modal="false"
			:before-close="handleClose"
			custom-class="plan-dialog">
			<el-form ref="form" :model="form" :rules="rules" label-position="top" size="mini">
				<el-row :gutter="20">
					<el-col :span="24">
						<el-form-item label="变动类型" prop="changeType">
							<!--  -->
							<el-radio-group v-model="form.changeType" size="small">
								<el-radio-button v-for="item in $menu.getList('AssetChangeType')" :key="item.value" :label="item.value">
									{{ item.name }}
								</el-radio-button>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="资产编号" prop="assetNo">
							<el-input v-model="form.assetNo" placeholder="请填写资产编号" size="small" style="width: 100%" disabled />
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="变动日期" prop="changeDate">
							<el-date-picker
								v-model="form.changeDate"
								value-format="yyyy-MM-dd"
								type="date"
								placeholder="请选择变动日期"
								style="width: 100%"
								size="small" />
						</el-form-item>
					</el-col>
					<template v-if="form.changeType === 'RECEIVE_REGISTRATION'">
						<el-col :span="12">
							<el-form-item label="接收方式" prop="receiveMethod">
								<el-select v-model="form.receiveMethod" placeholder="请选择接收方式" size="small" style="width: 100%">
									<el-option v-for="(item, index) in []" :key="index" :label="item.label" :value="item.value" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="接收金额(元)" prop="receiveAmount">
								<el-input v-model="form.receiveAmount" size="small" placeholder="请填写接收金额" />
							</el-form-item>
						</el-col>
					</template>
					<template v-if="form.changeType === 'ASSET_CHANGE'">
						<el-col :span="24">
							<el-form-item label="变更类型" prop="changeSubType">
								<el-select v-model="form.changeSubType" placeholder="请选择变更类型" size="small" style="width: 100%">
									<!-- <el-option v-for="(item, index) in []" :key="index" :label="item.label" :value="item.value" /> -->
									<el-option label="原值变更" value="原值变更" />
									<el-option label="面积变更" value="面积变更" />
									<el-option label="状态变更" value="状态变更" />
									<el-option label="所属项目变更" value="所属项目变更" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="变更前内容" prop="changeBefore">
								<el-input v-model="form.changeBefore" size="small" placeholder="请填写变更前内容" />
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="变更后内容" prop="changeAfter">
								<el-input v-model="form.changeAfter" size="small" placeholder="请填写变更后内容" />
							</el-form-item>
						</el-col>
					</template>
					<template v-if="form.changeType === 'DISPOSAL_RECORD'">
						<el-col :span="12">
							<el-form-item label="处置方式" prop="disposeMethod">
								<el-select v-model="form.disposeMethod" placeholder="请选择处置方式" size="small" style="width: 100%">
									<el-option v-for="(item, index) in []" :key="index" :label="item.label" :value="item.value" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="处置金额(元)" prop="disposeAmount">
								<el-input v-model="form.disposeAmount" size="small" placeholder="请填写处置金额" />
							</el-form-item>
						</el-col>
					</template>
					<el-col :span="12">
						<el-form-item label="变动说明" prop="changeDescription">
							<el-input v-model="form.changeDescription" type="textarea" :rows="3" placeholder="请输入变动说明" />
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="附件上传" prop="attachments">
							<FileUpload
								ref="upload"
								:limit="3"
								:accept="['jpg', 'png', 'jpeg', 'pdf']"
								v-model="uploadFiles"
								title="上传凭证附件"
								@success="handleUploadSuccess">
								<template slot="tip">请上传接收凭证、评估报告、审批文件等</template>
							</FileUpload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 按钮 -->
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="handleSubmit">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { getAssetChangeSave } from '@/api/asset/assetDynamicApi.js';
	export default {
		name: 'AssetDynamicDialog',
		props: {
			dialogVisible: Boolean,
			data: {
				type: Object,
				default: () => ({}),
			},
		},
		data() {
			return {
				uploadFiles: [],
				form: {
					changeType: 'RECEIVE_REGISTRATION',
					assetId: '',
					assetNo: '',
					changeDate: '',
					receiveMethod: '',
					receiveAmount: '',
					changeSubType: '',
					changeBefore: '',
					changeAfter: '',
					disposeMethod: '',
					disposeAmount: '',
					changeDescription: '',
					attachments: '',
				},
				rules: {
					changeType: [{ required: true, message: '请选择变动类型', trigger: 'change' }],
					assetNo: [{ required: true, message: '请选择资产编号', trigger: 'blur' }],
					changeDate: [{ required: true, message: '请选择变动日期', trigger: 'change' }],
					receiveMethod: [{ required: true, message: '请选择接收方式', trigger: 'change' }],
					changeSubType: [{ required: true, message: '请选择变更类型', trigger: 'change' }],
					changeBefore: [{ required: true, message: '请填写变更前内容', trigger: 'blur' }],
					changeAfter: [{ required: true, message: '请填写变更前内容', trigger: 'blur' }],
					disposeMethod: [{ required: true, message: '请选择处置方式', trigger: 'change' }],
					changeDescription: [{ required: true, message: '请输入变动说明', trigger: 'blur' }],
					attachments: [{ required: true, message: '请上传凭证附件', trigger: 'change' }],
				},
			};
		},
		watch: {
			dialogVisible(val) {
				if (val) {
					this.$nextTick(() => {
						this.$refs.form && this.$refs.form.resetFields();
						this.form.assetNo = this.data.assetNo;
						this.form.assetId = this.data.id;
					});
				} else {
					this.$refs.upload.reset();
				}
			},
		},
		methods: {
			handleClose() {
				this.$emit('update:dialogVisible', false);
			},
			handleUploadSuccess(res, fileList) {
				this.form.attachments = fileList.map(item => item.response).join(',');
			},
			handleSubmit() {
				console.log(this.form);
				this.$refs.form.validate(valid => {
					if (!valid) return;
					getAssetChangeSave(this.form)
						.then(res => {
							this.$message.success('新增成功');
							this.$emit('updateSuccess');
						})
						.catch(err => {
							console.log(err);
							this.$message.error('新增失败');
						});
					this.handleClose();
				});
			},
		},
	};
</script>

<style scoped lang="scss">
	:deep(.plan-dialog) {
		.el-dialog__body {
			max-height: 60vh; // 控制最大高度
			overflow-y: auto; // 开启纵向滚动
		}
		/* 整体滚动条宽度 */
		.el-dialog__body::-webkit-scrollbar {
			width: 6px;
		}

		/* 滚动条轨道 */
		.el-dialog__body::-webkit-scrollbar-track {
			background: #f5f5f5;
			border-radius: 3px;
		}

		/* 滑块 */
		.el-dialog__body::-webkit-scrollbar-thumb {
			background: #c1c1c1;
			border-radius: 3px;
			transition: all 0.3s;
		}

		/* hover 时 */
		.el-dialog__body::-webkit-scrollbar-thumb:hover {
			background: #a8a8a8;
		}
	}
</style>
